export class HistoricoFormacao {
    constructor({
      id = null,
      avaliacaoId = null,
      formacao = null,
      dataRealizacao = null,
      origemId = null,
      situacao = null,
      dataInicio = null,
      dataFim = null,
      cargaHoraria = null,
      localRealizacao = null,
      instrutores = Array(),
      questoes = Array(),
    }) {
        this.id = id;
        this.avaliacaoId = avaliacaoId;
        this.formacao = formacao;
        this.dataRealizacao = dataRealizacao;
        this.origemId = origemId;
        this.situacao = situacao;
        this.dataInicio = dataInicio;
        this.dataFim = dataFim;
        this.cargaHoraria = cargaHoraria;
        this.localRealizacao = localRealizacao;
        this.instrutores = instrutores;
        this.questoes = questoes;
    }
    static Build() {
      return new HistoricoFormacao({
        id: null,
        avaliacaoId: null,
        formacao: null,
        dataRealizacao: null,
        origemId: null,
        situacao: null,
        dataInicio: null,
        dataFim: null,
        cargaHoraria: null,
        localRealizacao: null,
        instrutores: Array(),
      });
    }
    format() {
      return {
        id: this.id,
        avaliacaoId: this.avaliacaoId,
        formacao: this.formacao,
        dataRealizacao: this.dataRealizacao,
        origemId: this.origemId,
        situacao: this.situacao,
        dataInicio: this.dataInicio,
        dataFim: this.dataFim,
        cargaHoraria: this.cargaHoraria,
        localRealizacao: this.localRealizacao,
        instrutores: this.instrutores
      };
    }
  }
  